import { render, staticRenderFns } from "./FollowupInfo.vue?vue&type=template&id=78466968"
import script from "./FollowupInfo.vue?vue&type=script&lang=js"
export * from "./FollowupInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports